var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationBurgerWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.0034H22C22.6875 15.0034 23.25 14.4409 23.25 13.7534C23.25 13.0659 22.6875 12.5034 22 12.5034H2C1.3125 12.5034 0.75 13.0659 0.75 13.7534C0.75 14.4409 1.3125 15.0034 2 15.0034ZM2 8.75342H22C22.6875 8.75342 23.25 8.19092 23.25 7.50342C23.25 6.81592 22.6875 6.25342 22 6.25342H2C1.3125 6.25342 0.75 6.81592 0.75 7.50342C0.75 8.19092 1.3125 8.75342 2 8.75342ZM0.75 1.25342C0.75 1.94092 1.3125 2.50342 2 2.50342H22C22.6875 2.50342 23.25 1.94092 23.25 1.25342C23.25 0.565918 22.6875 0.00341797 22 0.00341797H2C1.3125 0.00341797 0.75 0.565918 0.75 1.25342Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationBurgerWhite);
export default __webpack_public_path__ + "static/media/navigation_burger_white.8112ec256a3d7d504880838af81929bb.svg";
export { ForwardRef as ReactComponent };